module.exports = __webpack_public_path__ + "static/img/header-logo.04e09433.png";